import axios from "axios";
import QueryParameter from "./QueryParameter";

export interface IEndpointProps {
    rootUrl: string;
}

export default class EndpointsBaseClass {
    constructor(props: IEndpointProps) {
        const { rootUrl } = props;

        axios.defaults.baseURL = this.removeSlash(`${this.removeSlash(rootUrl)}`);
    }

    protected async makeGetRequest(url: string, queryParameters?: QueryParameter[]) {
        const queryParameterString: string = this.constructCliParamString(queryParameters);

        const response = await axios.get(`${url}${queryParameterString}`);

        return response.data;
    }

    protected async makePostRequest<T>(url: string, data: T) {
        const response = await axios.post(url, data);

        return response.data;
    }

    private constructCliParamString(params?: QueryParameter[]): string {
        if (!params) return "";

        let builtParams: string[] = [];
        params.forEach((param) => {
            const builtParam = param.buildParamString();

            if (builtParam.length === 0) return;

            builtParams.push(builtParam);
        });

        if (builtParams.length === 0) return "";

        return `?${builtParams.join("&").trim()}`;
    }

    private removeSlash(str: string) {
        return str
            .replace(/^\/*/gm, "") // remove slash prefix
            .replace(/\/*$/gm, ""); // remove slash suffix;
    }
}
